<template>
    <div class="m-t">
        <strong>Paczki w przesyłce</strong>
        <div class="form-group row" v-for="(piece, index) in pieceList" :key="index">
            <label class="col-sm-1 form-control-label">#{{index + 1}} </label>
            <div class="col-sm-2 input-group">
                <select class="form-control" v-model="piece.type">
                    <option value="PACKAGE">Paczka</option>
                    <option value="ENVELOPE">Koperta</option>
                    <option value="PALLET">Paleta</option>
                </select>
                <span class="input-group-addon">typ</span>
            </div>
            <div class="col-sm-1 input-group">
                <input type="number" step="0.1" class="form-control" v-model.number="piece.weight" placeholder="Kg">
                <span class="input-group-addon text-sm p-a-xs">kg</span>
            </div>
            <div class="col-sm-1 input-group" v-if="piece.type !== 'ENVELOPE'">
                <input type="number" class="form-control" v-model.number="piece.length" placeholder="Dłg.">
                <span class="input-group-addon text-sm p-a-xs">cm</span>
            </div>
            <div class="col-sm-1 input-group" v-if="piece.type !== 'ENVELOPE'">
                <input type="number" class="form-control" v-model.number="piece.width" placeholder="Szer.">
                <span class="input-group-addon text-sm p-a-xs">cm</span>
            </div>
            <div class="col-sm-1 input-group" v-if="piece.type !== 'ENVELOPE'">
                <input type="number" class="form-control" v-model.number="piece.height" placeholder="Wys.">
                <span class="input-group-addon text-sm p-a-xs">cm</span>
            </div>
            <div class="col-sm-2">
                <label class="md-check">
                    <input v-model="piece.nonStandard" type="checkbox" class="">
                    <i class="blue"/> Niestandardowa
                </label>
            </div>
            <div class="col-sm-1">
                <button type="button" class="btn white" tabindex="-1" @click="pieceList.splice(index, 1)">Usuń</button>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-2 form-control-label">Dodaj paczkę</label>
            <div class="col-sm-3">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addNewPiece('PACKAGE', 1, 20,20,20)">+ Paczka (20x20x20, 1kg)</button>
            </div>
            <div class="col-sm-3">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addNewPiece('PALLET', 100, 120,80,100)">+ Paleta (120x80x100, 100kg)</button>
            </div>
            <div class="col-sm-3">
                <button class="btn btn-outline btn-xs rounded b-info text-info" @click.prevent="addNewPiece('ENVELOPE', 0.5, 0,0,0)">+ Koperta (0.5kg)</button>
            </div>
        </div>

        <hr>
        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Zawartość</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="content" placeholder="Zawartość przesyłki">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Referencja</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="reference" placeholder="Referencja własna (opcjonalnie)">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Komentarz</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" v-model="comment" placeholder="Komentarz (opcjonalnie)">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Usługa DHL</label>
            <div class="col-sm-4">
                <v-select placeholder="Kod usługi DHL (np. AH)" v-model="serviceDetails.product"  :options="serviceCodes" label="label" :reduce="t => t.id"/>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Data nadania</label>
            <div class="col-sm-4">
                <input type="date" class="form-control" v-model="shipmentDate">
                <small class="text-muted">Domyślnie dzisiejsza data. Format YYYY-MM-DD.</small>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-sm-3 form-control-label">Opcje dodatkowe</label>
            <div class="col-sm-8">
                <p>
                    <label class="md-check">
                        <input v-model="serviceDetails.collectOnDelivery.enabled" type="checkbox" class="">
                        <i class="blue"/> Za pobraniem (COD)
                    </label>
                </p>
                <div v-if="serviceDetails.collectOnDelivery.enabled">
                    <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Kwota pobrania</label>
                        <div class="col-sm-4">
                            <input type="number" step="0.01" class="form-control" v-model.number="serviceDetails.collectOnDelivery.value" placeholder="Kwota">
                        </div>
                        <div class="col-sm-4">
                            <select class="form-control" v-model="serviceDetails.collectOnDelivery.form">
                                <option value="BANK_TRANSFER">Przelew bankowy</option>
                                <option value="CASH">Gotówka</option>
                            </select>
                        </div>
                    </div>
                </div>
                <p>
                    <label class="md-check">
                        <input v-model="serviceDetails.insurance.enabled" type="checkbox" class="">
                        <i class="blue"/> Ubezpieczenie
                    </label>
                </p>
                <div v-if="serviceDetails.insurance.enabled">
                    <div class="form-group row">
                        <label class="col-sm-3 form-control-label">Wartość ubezpieczenia</label>
                        <div class="col-sm-4">
                            <input type="number" step="0.01" class="form-control" v-model.number="serviceDetails.insurance.value" placeholder="Wartość">
                        </div>
                    </div>
                </div>
            </div>
            <Spinner v-if="isProcessing"/>
        </div>

        <a v-if="!isStockOrderPickup" href="#" class="btn info none-radius m-t" @click.prevent="save" :class="{disabled: isProcessing || pieceList.length === 0}">Zapisz</a>
        <a v-if="isStockOrderPickup" href="#" class="btn primary none-radius m-t" @click.prevent="createPickUp" :class="{disabled: isProcessing || pieceList.length === 0}">Zamów odbiór</a>

    </div>
</template>
<script>
import Spinner from '../../Spinner.vue';
import Api from '../../../Api.js';

// Helper do rozdzielania ulicy i numeru domu
function splitStreetAndHouseNumber(fullStreet) {
    if (!fullStreet) return { street: '', houseNumber: '' };
    const match = fullStreet.match(/^(.*?)\s+([\w\d/-]+)$/);
    if (match) {
        return { street: match[1].trim(), houseNumber: match[2].trim() };
    }
    return { street: fullStreet.trim(), houseNumber: '' }; // Fallback
}

export default {
    name: 'CarrierDhl',
    props: {
        order: Object,
        sender: Object,
        recipient: Object,
        stockOrder: Object,
        selectedBoxAndPallets: Array
    },
    components: {
        Spinner
    },
    data: function () {
        return {
            isProcessing: false,
            pieceList: [], // Zamiast parcels
            content: "Filtry powietrza",
            comment: "",
            reference: (this.order && this.order.invoiceNo) ? this.order.invoiceNo : "",
            shipmentDate: new Date().toISOString().slice(0,10), // Domyślnie dzisiaj
            serviceDetails: {
                product: "AH", // Domyślna usługa krajowa DHL
                collectOnDelivery: {
                    enabled: false,
                    value: 0,
                    form: "BANK_TRANSFER" // Domyślnie BANK_TRANSFER lub CASH
                },
                insurance: {
                    enabled: false,
                    value: 0
                }
            },
            serviceCodes: [
                { id: "AH", label: "AH - przesyłka krajowa" },
                { id: "PR", label: "PR - przesyłka Premium" },
                { id: "09", label: "09 - Domestic 09" },
                { id: "12", label: "12 - Domestic 12" },
                { id: "DW", label: "DW - evening delivery shipment" },
                { id: "SP", label: "SP - przesyłka z doręczeniem do punktu" },
                { id: "EK", label: "EK - przesyłka Connect" },
                { id: "PI", label: "PI - przesyłka International" },
                { id: "CP", label: "CP - przesyłka Connect Plus" },
                { id: "CM", label: "CM - przesyłka Connect Plus Pallet" }
            ],
            isStockOrderPickup: false // DHL może nie mieć bezpośredniego "zamów odbiór" w ten sam sposób co DPD/Geis dla stockOrder
        }
    },
    created: function() {
        if (this.order && this.order.clientNo && this.order.clientNo.length > 0) {
            this.content = "Filtry powietrza - numer zamówienia " + this.order.clientNo;
        }
        if (this.order && this.order.deliveryIsCod) {
            this.serviceDetails.collectOnDelivery.enabled = true;
            // Można by spróbować pobrać kwotę z zamówienia, jeśli jest dostępna
            // this.serviceDetails.collectOnDelivery.value = this.order.codValue || 0;
        }

        if (Object.keys(this.order || {}).length === 0 && Object.keys(this.stockOrder || {}).length > 0) {
            this.isStockOrderPickup = true; // Należy zweryfikować, czy DHL obsługuje taki przepływ
        }

        // Domyślna paczka, jeśli nie ma nic z zamówienia
        if (!this.selectedBoxAndPallets || this.selectedBoxAndPallets.length === 0) {
            this.addNewPiece('PACKAGE', 1, 20, 20, 20);
        }

        if (this.selectedBoxAndPallets && this.selectedBoxAndPallets.length > 0) {
            this.setBoxesAndPallets();
        }
    },
    methods: {
        addNewPiece: function(type, weight, length, width, height) {
            const newPiece = {
                type: type,
                weight: weight,
                quantity: 1,
                nonStandard: false // Domyślnie false
                // blpPieceId: "Karton #" + (this.pieceList.length + 1) // Opcjonalne
            };
            if (type !== 'ENVELOPE') {
                newPiece.length = length;
                newPiece.width = width;
                newPiece.height = height;
                // Automatyczne zaznaczenie nonStandard na podstawie wymiarów
                if (length > 120 || width > 60 || height > 60) {
                    newPiece.nonStandard = true;
                }
            }
            this.pieceList.push(newPiece);
        },

        setBoxesAndPallets() { // Dostosowane do DHL pieceList
            this.pieceList.length = 0;
            if (!this.order || !this.order.boxes) return;

            for (let i = 0; i < this.order.boxes.length; i++) {
                const box = this.order.boxes[i];
                const id = this.selectedBoxAndPallets.find(s => s == box._id);
                if (!id) continue;

                this.pieceList.push({
                    type: "PACKAGE", // Założenie, że boxy z zamówienia to paczki
                    weight: box.mass,
                    length: Math.round(box.length / 10),
                    width: Math.round(box.width / 10),
                    height: Math.round(box.height / 10),
                    quantity: 1, // Założenie: jeden box to jedna sztuka w pieceList
                    nonStandard: (Math.round(box.length / 10) > 120 || Math.round(box.width / 10) > 60 || Math.round(box.height / 10) > 60)
                    // blpPieceId: "#" + (this.pieceList.length + 1) + " KOD: " + box.code.toUpperCase()
                });
            }
        },
        // Metoda createPickUp może wymagać innej logiki dla DHL lub być nieużywana
        async createPickUp() {
            this.$h.errorNotif("Funkcja 'Zamów odbiór' nie jest jeszcze zaimplementowana dla DHL.");
            // this.isProcessing = true;
            // const data = this.setData();
            // data.stockOrder = this.stockOrder._id;
            // try {
            //     await Api.shipments.dhlCreatePickup(data); // Potrzebny byłby dedykowany endpoint
            //     this.$h.success('Zlecono odbiór przesyłki DHL');
            //     this.$router.push({ path: `/shipments` });
            // } catch (e) {
            //     if (e.response && e.response.data && e.response.data.error) this.$h.errorNotif(e.response.data.error);
            //     else this.$h.commonApiError(e, true);
            // }
            // this.isProcessing = false;
        },
        save: async function() {
            if (this.pieceList.length === 0) {
                this.$h.errorNotif("Przesyłka musi zawierać co najmniej jedną paczkę.");
                return;
            }
            this.isProcessing = true;
            const payload = this.setData();
            if (this.order && this.order._id) payload.order = this.order._id;
            // Jeśli isStockOrderPickup jest true, można dodać stockOrder._id
            // if (this.isStockOrderPickup && this.stockOrder && this.stockOrder._id) payload.stockOrder = this.stockOrder._id;

            try {
                const shipments = await Api.shipments.dhlSent(payload); // API przyjmuje obiekt z polem "packages"
                this.$emit('shipments', shipments); // Zakładając, że API zwraca tablicę przetworzonych przesyłek
                this.$h.success('Dodano przesyłkę DHL');
            } catch (e) {
                if (e.response && e.response.data && e.response.data.message) {
                    this.$h.errorNotif(`Błąd DHL: ${e.response.data.message}`);
                } else if (e.response && e.response.data && e.response.data.error) {
                    this.$h.errorNotif(e.response.data.error);
                } else {
                    this.$h.commonApiError(e, true);
                }
            }
            this.isProcessing = false;
        },
        setData: function() {
            const dhlPackage = {
                shipper: this.setShipper(),
                receiver: this.setReceiver(),
                pieceList: this.pieceList.map(p => {
                    const piece = { ...p };
                    if (piece.type === 'ENVELOPE') {
                        delete piece.length;
                        delete piece.width;
                        delete piece.height;
                    }
                    return piece;
                }),
                service: {
                    product: this.serviceDetails.product
                },
                shipmentDate: this.shipmentDate, // Dodana data nadania
                content: this.content,
                comment: this.comment || undefined, // Wyślij undefined jeśli pusty, aby nie wysyłać pustego stringa jeśli API tego nie lubi
                reference: this.reference || undefined
            };

            if (this.serviceDetails.collectOnDelivery.enabled && this.serviceDetails.collectOnDelivery.value > 0) {
                dhlPackage.service.collectOnDelivery = true;
                dhlPackage.service.collectOnDeliveryValue = this.serviceDetails.collectOnDelivery.value;
                dhlPackage.service.collectOnDeliveryForm = this.serviceDetails.collectOnDelivery.form;
            }

            if (this.serviceDetails.insurance.enabled && this.serviceDetails.insurance.value > 0) {
                dhlPackage.service.insurance = true;
                dhlPackage.service.insuranceValue = this.serviceDetails.insurance.value;
            }
            // API DHL oczekuje obiektu z kluczem "packages", który jest tablicą.
            // W tym przypadku tworzymy jedną przesyłkę DHL, więc tablica będzie jednoelementowa.
            return { packages: [dhlPackage] };
        },
        setShipper: function() {
            const { street, houseNumber } = splitStreetAndHouseNumber(this.sender.street);
            return {
                name: this.sender.company_name || (this.sender.firstname + " " + this.sender.lastname),
                postalCode: this.sender.postcode ? this.sender.postcode.replace('-', '') : "",
                city: this.sender.city,
                street: street,
                houseNumber: houseNumber,
                contactPhone: this.sender.phone || "",
                contactEmail: this.sender.email || undefined,
                country: this.sender.countryCode || "PL",
                addressType: "B" // Założenie: nadawca to firma
            };
        },
        setReceiver: function() {
            const { street, houseNumber } = splitStreetAndHouseNumber(this.recipient.street);
            return {
                name: this.recipient.name, // Nazwa firmy lub imię i nazwisko
                postalCode: this.recipient.postCode ? this.recipient.postCode.replace('-', '') : "",
                city: this.recipient.city,
                street: street,
                houseNumber: houseNumber,
                contactPerson: this.recipient.contactPerson || undefined,
                contactPhone: this.recipient.phone || "",
                contactEmail: this.recipient.email || undefined,
                country: this.recipient.countryCode || "PL",
                // Prosta logika do określenia addressType, można ją rozbudować
                addressType: (this.recipient.name && (this.recipient.name.toLowerCase().includes("sp. z o.o.") || this.recipient.name.toLowerCase().includes("s.a."))) ? "B" : "C"
            };
        }
    },
    watch: {
        pieceList: {
            handler: function(newPieceList) {
                newPieceList.forEach(piece => {
                    if (piece.type === 'PACKAGE' || piece.type === 'PALLET') {
                        const length = parseFloat(piece.length) || 0;
                        const width = parseFloat(piece.width) || 0;
                        const height = parseFloat(piece.height) || 0;
                        piece.nonStandard = (length > 120 || width > 60 || height > 60);
                    }
                });
            },
            deep: true // Potrzebne do obserwowania zmian wewnątrz obiektów w tablicy
        }
    }
}
</script>

<style scoped lang="scss">
  .app .select2-container .select2-selection--single {
    height: 44px!important;
  }
  .app .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 8px!important;
  }
  .input-group-addon {
    min-width: 30px; /* Aby "kg", "cm" itp. miały podobną szerokość */
    text-align: center;
  }
</style>
